
import { Component, Prop, Vue } from "vue-property-decorator";

const BLOCKED_TITLE_CLASS = "compliance-block__title_blocked";

@Component
export default class ComplianceBlock extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly blocked!: boolean;

  get classes() {
    return {
      [`${BLOCKED_TITLE_CLASS}`]: this.blocked,
    };
  }
}
